<template>
  <v-hover
    v-slot="{ hover }"
    open-delay="200"
    close-delay="200"
  >
  <v-card
    :elevation="hover && !esAgotado ? 4 : 0"
    :class="{ 'on-hover': hover && !esAgotado, 'product-card--agotado': esAgotado }"
    class="product-card"
    @click="viewProduct"
    outlined
  >
    <template v-if="!hasNoImage">
      <div class="image-wrap">
        <v-img
          :src="product.detalle.srcImg"
          :alt="product.nombre"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.05), rgba(0,0,0,.35)"
          height="180px"
        >
          <v-card-title v-text="product.nombre"></v-card-title>
        </v-img>
        <div v-if="!esAgotado && product.esMasVendido" class="best-seller-badge">
          <v-icon x-small color="teal darken-1">mdi-star</v-icon>
          <span>Más vendido</span>
        </div>
        <v-chip
          v-if="currentCartCount > 0 && !esAgotado"
          small
          color="secondary"
          class="qty-badge"
        >x{{ currentCartCount }}</v-chip>
      </div>
    </template>
    <template v-else>
      <div class="image-wrap no-img">
        <v-card-title class="product-name-no-img-alt" v-text="product.nombre"></v-card-title>
        <div v-if="!esAgotado && product.esMasVendido" class="best-seller-badge">
          <v-icon x-small color="teal darken-1">mdi-star</v-icon>
          <span>Más vendido</span>
        </div>
        <v-chip
          v-if="currentCartCount > 0 && !esAgotado"
          small
          color="secondary"
          class="qty-badge"
        >x{{ currentCartCount }}</v-chip>
      </div>
    </template>
    <v-card-text class="product-body">
      <div v-if="tieneDescuento" class="price-block">
        <span class="price-discount">$ {{ descuento }}&nbsp;</span>
        <del class="price-original">${{ product.precio }}</del>
      </div>
      <div v-else class="price-block">
        <span class="price">$ {{ product.precio }}</span>
      </div>
      <p v-if="hover && product.descripcion" class="mt-2 mb-0 product-desc">{{ product.descripcion }}</p>
      <div class="status-slot">
        <v-chip
          v-if="!categoriaDisponible"
          small
          label
          class="status-chip status-chip--horario"
        >Fuera de horario</v-chip>
        <v-chip
          v-else-if="esAgotado"
          small
          label
          color="error"
          dark
          class="status-chip status-chip--agotado"
        >Agotado</v-chip>
      </div>
    </v-card-text>
  </v-card>
  </v-hover>
</template>
<script>
import { mapGetters } from 'vuex'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import { saveCatalogPosition } from '@/helpers/catalogScroll.js'
import { isProductoAgotado } from '@/helpers/productoAgotado.js'

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object
    },
    categoriaDisponible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('App', ['tiendaCerrada']),
    ...mapGetters('Carrito', ['getItems']),
    esAgotado () {
      return isProductoAgotado(this.product)
    },
    descuento () {
      return descuentoHelper.precioConDescuento(this.product)
    },
    tieneDescuento () {
      return Number(this.descuento) !== Number(this.product.precio)
    },
    hasNoImage () {
      return this.product && this.product.detalle && this.product.detalle.srcImg && this.product.detalle.srcImg.includes('noimage_Producto.png')
    },
    currentCartCount () {
      if (!this.product) return 0
      const matches = (this.getItems || []).filter(i => i.productId === this.product.id)
      if (!matches.length) return 0
      return matches.reduce((sum, it) => sum + (Number(it.cant) || 0), 0)
    }
  },
  methods: {
    viewProduct () {
      if (this.tiendaCerrada || this.esAgotado) return
      saveCatalogPosition(this.$route)
      const code = this.$clientCode()
      this.$router.push({
        name: 'Producto',
        params: {
          client: code,
          id: this.product.id
        }
      })
    }
  }
}
</script>
<style scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
.product-card {
  cursor: pointer;
  border-radius: 12px !important;
  transition: box-shadow .2s ease, transform .15s ease;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.product-card--agotado {
  cursor: default;
  opacity: 0.85;
}
.on-hover {
  transform: translateY(-2px);
}
.image-wrap {
  position: relative;
  flex-shrink: 0;
}
.product-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.price-block {
  min-height: 1.5rem;
}
.best-seller-badge {
  position: absolute;
  left: 8px;
  top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: rgba(255, 255, 255, 0.94);
  color: #00695c;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  z-index: 1;
}
.qty-badge {
  position: absolute;
  right: 8px;
  top: 8px;
  font-weight: 700 !important;
  z-index: 1;
}
.price,
.price-discount {
  font-weight: 700;
  font-size: 1.25rem;
}
.price-original {
  color: rgba(0, 0, 0, 0.45);
}
.product-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.status-slot {
  margin-top: 8px;
  min-height: 28px;
  display: flex;
  align-items: center;
}
.status-chip {
  height: 24px !important;
  font-weight: 700 !important;
}
.status-chip--horario {
  background: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.65) !important;
}
.status-chip--agotado {
  font-weight: 800 !important;
}
.product-name-no-img-alt {
  text-align: center;
  padding: 16px;
  word-break: normal;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}
</style>
